import { render } from "./ThankYouPage.vue?vue&type=template&id=237efd1d&scoped=true&ts=true"
import script from "./ThankYouPage.vue?vue&type=script&lang=ts"
export * from "./ThankYouPage.vue?vue&type=script&lang=ts"

import "./ThankYouPage.vue?vue&type=style&index=0&id=237efd1d&scoped=true&lang=css"

import exportComponent from "/home/runner/work/a-gallery-tvp/a-gallery-tvp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-237efd1d"]])

export default __exports__